// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"a262ae94","42":"e04ae927","440":"a262ae94","671":"f0d8fa1e","827":"e04ae927"}[chunkId] + ".chunk.css";
};